export default __webpack_public_path__ + "static/media/election-icon.eea9fe8e.svg";